import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#fff',
        success: '#7fce38',
        error: '#e24485',
        info: '#2bbad8',
        warning: '#fbe965',
        secondary: '#313131',
      },
      dark: {
        primary: '#0086ca',
        success: '#7fce38',
        error: '#e24485',
        info: '#2bbad8',
        warning: '#fbe965',
      },
    },
  },
});
